const { default: Swiper } = require('swiper');
const { Pagination } = require('swiper/modules');

const sections = document.querySelectorAll('section.offers-list');

if (sections.length) {
    sections.forEach(section => {
        const swiperElement = section.querySelector('.swiper');
        const paginationElement = section.querySelector('[swiper-pagination]');

        if (!swiperElement) return;

        let swiper = null;

        const createSwiper = () => {
            let args = {
                slidesPerView: 1.08,
                spaceBetween: 16,
                modules: [Pagination],
                pagination: {
                    el: paginationElement,
                    type: 'progressbar',
                },
            };

            swiper = new Swiper(swiperElement, args);
        };

        const destroySwiper = () => {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        };

        const handleSwiper = () => {
            if (window.innerWidth >= 1024) {
                destroySwiper();
            } else {
                if (!swiper) {
                    createSwiper();
                }
            }
        };

        // initial check
        handleSwiper();

        window.addEventListener('resize', handleSwiper);
    });
}
